/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

export const props = () => ({
  MuiCheckbox: {
    color: 'primary',
    icon: <span />,
    checkedIcon: <span />,
  },
  MuiButton: {
    variant: 'contained',
    disableElevation: true,
  },
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiTextField: {
    variant: 'outlined',
  },
  MuiChip: {
    size: 'small',
  },
  MuiBreadcrumbs: {
    separator: '>',
  },
  MuiTooltip: {
    placement: 'right',
    arrow: true,
  },
});
